export enum TestIds {
  OverallEffectiveness = 'overallEffectiveness',
  PerformedBy = 'performedBy',
  TestType = 'testType',
}
